import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
// import Iconify from 'src/components/iconify';
// import Label from 'src/components/label';
import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  city: icon('city-15'),
  violation: icon('warning-45'),
  vehicles: icon('sharpicons_truck'),
  driver: icon('icon_-driver'),
  file: icon('ic_file'),
  garbageUnloading: icon('sey-garbage-b'),
  supervisor: icon('supervisor-4'),
  users: icon('065-users'),
  regions: icon('40-locations-2'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  settings: icon('ic_settings'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();

  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: t('overview'),
        items: [
          {
            title: t('dashboard'),
            path: paths.mardam.root,
            icon: ICONS.dashboard,
          },
          {
            title: t('garbage_unloading'),
            path: paths.mardam.others.garbageUnloading,
            icon: ICONS.garbageUnloading,
          },
          {
            title: t('contractor_report'),
            path: paths.mardam.others.garbageReport,
            icon: ICONS.analytics,
          },
          {
            title: t('users'),
            path: paths.mardam.general.tenants,
            icon: ICONS.users,
          },
          {
            title: t('cities_and_municipalities'),
            path: paths.mardam.general.cities.cityList,
            icon: ICONS.city,
          },
          {
            title: t('violations'),
            path: paths.mardam.general.violations.violationList,
            icon: ICONS.violation,
          },
          {
            title: t('setup'),
            path: paths.mardam.general.scale,
            icon: ICONS.settings,
            children: [
              { title: t('scale'), path: paths.mardam.general.scale },
              { title: t('hardware'), path: paths.mardam.general.hardware },
              { title: t('zones'), path: paths.mardam.general.zones },
              {
                title: t('Landfill Areas'),
                path: paths.mardam.general.geographicalLocations,
              },
              {
                title: t('types of wastes'),
                path: paths.mardam.general.typesOfWastes,
              },
              {
                title: t('types of vehicles'),
                path: paths.mardam.general.typesOfVehicles,
              },
            ],
          },
        ],
      },

      {
        subheader: t('pickup_points_management'),
        items: [
          {
            title: t('pickup_points'),
            path: paths.mardam.pickup.pickupPoints,
            icon: ICONS.tour,
          },
          {
            title: t('regions'),
            path: paths.mardam.regions.regionsList,
            icon: ICONS.regions,
          },
        ],
      },
      {
        subheader: t('permit_management'),
        items: [
          {
            title: t('entry permits'),
            path: paths.mardam.general.entryPermits,
            icon: ICONS.banking,
          },
          {
            title: t('permits'),
            path: paths.mardam.general.permits,
            icon: ICONS.invoice,
          },
        ],
      },
      {
        subheader: t('contractors_management'),
        items: [
          {
            title: t('contractors'),
            path: paths.mardam.contractors.contractors,
            icon: ICONS.job,
          },
          { title: t('contracts'), path: paths.mardam.general.contracts, icon: ICONS.label },
          {
            title: t('vehicles'),
            path: paths.mardam.contractors.vehicles,
            icon: ICONS.vehicles,
          },
          {
            title: t('supervisors'),
            path: paths.mardam.contractors.superVisors,
            icon: ICONS.supervisor,
          },
          {
            title: t('drivers'),
            path: paths.mardam.contractors.drivers,
            icon: ICONS.driver,
          },
        ],
      },

      // {
      //   subheader: t('others'),
      //   items: [
      //     {
      //       title: t('garbage unloading'),
      //       path: paths.mardam.others.garbageUnloading,
      //       icon: ICONS.garbageUnloading,
      //     },
      //   ],
      // },
      {
        subheader: t('configurations'),
        items: [
          { title: t('settings'), path: paths.mardam.general.settings, icon: ICONS.menuItem },
        ],
      },
    ],
    [t]
  );

  return data;
}
